var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w-badge h-6 inline-flex items-center justify-center text-sm rounded-full text-white px-3",class:{'bg-red-600 bg-opacity-80': _vm.warning}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }